import { Stack, StackProps } from "@mui/material";

export interface PageProps extends StackProps {

}

export default function Page({
    children,
    ...props
}: PageProps) {
    return <Stack sx={{
        minHeight: "100vh",
        width: "100vw",
        pageBreakAfter: "always",
    }}>
        <Stack flex={1} {...props}>
            {children}
        </Stack>
    </Stack>
}